module.exports = __webpack_public_path__ + "static/media/Mask Group (1).58c39fbd.jpg";